var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNavaidMiliaryCivil = function SvgNavaidMiliaryCivil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#389E0D",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12 17a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0-8.75a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20.75 10.75h-1.363a7.51 7.51 0 0 0-6.137-6.137V3.25h-2.5v1.363a7.51 7.51 0 0 0-6.137 6.137H3.25v2.5h1.363a7.51 7.51 0 0 0 6.137 6.137v1.363h2.5v-1.363a7.51 7.51 0 0 0 6.137-6.137h1.363zM12 18.25A6.25 6.25 0 1 1 18.25 12 6.257 6.257 0 0 1 12 18.25"
  })));
};
export { SvgNavaidMiliaryCivil as ReactComponent };
export default new URL("/codebuild/output/src3860153836/src/src/assets/svgs/navaid--miliary-civil.svg", import.meta.url).toString();